import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import AboutCard from "../../components/about-card/AboutCard";
import VisionMission from "../../components/vision-mission/VisionMission";

const TEAM = [
  { name: "Founder & CEO", init: "A", dept: "Leadership", bio: "Visionary behind AJERA Infotech with a passion for building solutions that matter." },
  { name: "CTO",           init: "K", dept: "Technology", bio: "Architecting robust, scalable systems with 10+ years of engineering excellence." },
  { name: "Head of Design",init: "P", dept: "Design",     bio: "Crafting intuitive user experiences that delight and convert." },
  { name: "Head of AI/ML", init: "R", dept: "AI & Data",  bio: "Leading intelligent automation initiatives across diverse industry verticals." },
];

const VALUES = [
  { icon:"🚀", title:"Innovation First",        desc:"We embrace emerging technology and constantly push the boundaries of what's possible." },
  { icon:"🎯", title:"Results Driven",          desc:"Every decision is measured against clear business outcomes and client success metrics." },
  { icon:"🤝", title:"Long-Term Partnership",   desc:"We don't just build — we grow with you as a trusted, long-term technology partner." },
  { icon:"🔒", title:"Trust & Transparency",   desc:"Open communication, honest timelines and full visibility at every step of the project." },
];

const About: React.FC = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-page-hero">
        <div className="about-page-hero__bg" />
        <div className="container">
          <span className="section-label">Who We Are</span>
          <h1 className="about-page-hero__title">
            Technology built for the
            <span className="gradient-text"> future</span>
          </h1>
          <p className="about-page-hero__sub">
            AJERA Infotech is a full-service technology company delivering web, mobile, AI,
            cloud and security solutions to businesses across India and globally.
          </p>
        </div>
      </section>
      
      {/* 5. ABOUT CARD */}
      <AboutCard />

      {/* Story */}
      <section id="story" className="ap-section">
        <div className="container">
          <div className="ap-story">
            <div className="ap-story__left">
              <span className="section-label">Our Story</span>
              <h2 className="section-title">Started with a problem,<br/>built to solve many</h2>
              <p style={{ color:"var(--gray-300)", fontSize:"0.95rem", lineHeight:"1.78", marginTop:"16px", fontWeight:300 }}>
                Founded in Tamil Nadu in 2025, AJERA Infotech was born out of a simple frustration:
                businesses were struggling to find technology partners who truly understood their
                problems and delivered solutions that lasted.
              </p>
              <p style={{ color:"var(--gray-300)", fontSize:"0.95rem", lineHeight:"1.78", marginTop:"12px", fontWeight:300 }}>
                Today we are a team of 50+ engineers, designers and strategists working on
                everything from startup MVPs to large-scale enterprise platforms — all under
                one roof, with one mission: build technology that creates real impact.
              </p>
              <Link to="/contact" className="btn-primary" style={{ marginTop:"28px", display:"inline-flex" }}>
                Work With Us
              </Link>
            </div>
            <div className="ap-story__right">
              <div className="ap-story__img">
                <img src="/erb3.webp" alt="AJERA Team" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section id="values" className="ap-section" style={{ background:"var(--gray-900)" }}>
        <div className="container">
          <span className="section-label">Our Values</span>
          <h2 className="section-title" style={{ marginBottom:"36px" }}>What drives us every day</h2>
          <div className="ap-values">
            {VALUES.map((v,i)=>(
              <div key={i} className="ap-value-card">
                <span className="ap-value-card__icon">{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      {/* <section id="team" className="ap-section">
        <div className="container">
          <span className="section-label">The People</span>
          <h2 className="section-title" style={{ marginBottom:"36px" }}>Meet our leadership</h2>
          <div className="ap-team">
            {TEAM.map((m,i)=>(
              <div key={i} className="ap-team-card">
                <div className="ap-team-card__avatar">{m.init}</div>
                <h3 className="ap-team-card__name">{m.name}</h3>
                <span className="ap-team-card__dept">{m.dept}</span>
                <p className="ap-team-card__bio">{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* 7. VISION / MISSION */}
      <VisionMission />

      {/* CTA */}
      <section className="ap-section" style={{ background:"var(--gray-900)" }}>
        <div className="container" style={{ textAlign:"center" }}>
          <span className="section-label">Let's Connect</span>
          <h2 className="section-title" style={{ margin:"8px auto 12px" }}>Ready to build together?</h2>
          <p className="section-subtitle" style={{ margin:"0 auto 28px" }}>
            Tell us about your project and let's create something great.
          </p>
          <Link to="/contact" className="btn-primary">Get In Touch</Link>
        </div>
      </section>
    </div>
  );
};

export default About;
